import React from 'react';
import { DataCenterWorldFooterConfig } from '../constants';
import './DataCenterWorldFooterEventInfo.scss';

interface DataCenterWorldFooterEventInfoProps {
  config: DataCenterWorldFooterConfig;
}

export default function DataCenterWorldFooterEventInfo({
  config,
}: DataCenterWorldFooterEventInfoProps) {
  const { title, subtitle, dates, venue, location, homeHref, contactHref } =
    config;

  return (
    <div
      className="c-dcw-footer-event-info"
      data-testid="dcw-footer-event-info"
    >
      <h2 className="c-dcw-footer-event-info__title">{title}</h2>
      <p className="c-dcw-footer-event-info__subtitle">{subtitle}</p>
      <p className="c-dcw-footer-event-info__dates">{dates}</p>
      <p className="c-dcw-footer-event-info__location">
        <span>{venue}</span>
        <span>{location}</span>
      </p>
      <nav className="c-dcw-footer-event-info__nav">
        <a href={homeHref} target="_blank" rel="noopener noreferrer">
          Home
        </a>
        <a href={contactHref} target="_blank" rel="noopener noreferrer">
          Contact Us
        </a>
      </nav>
    </div>
  );
}
